/** @jsx jsx */
import { jsx } from 'theme-ui'
import PropTypes from 'prop-types'
import styled from '@emotion/styled/macro'

const Video = styled.video({
  maxHeight: '100%',
  maxWidth: '100%',
})
const Source = styled.source({
  maxHeight: '100%',
  maxWidth: '100%',
})

const CustomVideo = ({ data, videoStyle, id }) => {
  //If data is retrieved from graphql within another app component use these props
  let description = data?.target?.embed?.description
  let file = data?.target?.embed?.file
  let thumbnail = data?.target?.thumbnail
  //If this is a linked entry in Rich Text use these props instead
  if (data?.fields) {
    file = data?.fields?.embed?.fields.file
    description = data?.fields?.embed?.fields.file
    thumbnail = data?.fields?.thumbnail
    videoStyle = { width: '100%' }
  }
  return (
    <Video
      id={id}
      poster={`https:${thumbnail?.url}`}
      controls
      style={videoStyle}
    >
      <Source
        src={`https:${file?.url}`}
        alt={description}
        sx={{ fontSize: 16, mb: 5 }}
      />
    </Video>
  )
}

CustomVideo.propTypes = {
  data: PropTypes.object.isRequired,
  videoStyle: PropTypes.object,
  id: PropTypes.string,
}

export default CustomVideo
